// extracted by mini-css-extract-plugin
export var categories = "shop-header-module--categories--Mizkc";
export var filterHeader = "shop-header-module--filterHeader--Jo5Xy";
export var filterTag = "shop-header-module--filterTag--uSjVK";
export var filtersClosed = "shop-header-module--filtersClosed--8jh4P";
export var filtersOpen = "shop-header-module--filtersOpen--oLO3w";
export var headerContainer = "shop-header-module--headerContainer--jAhHU";
export var mobileCategoriesClosed = "shop-header-module--mobileCategoriesClosed--z7pbO";
export var mobileCategoriesOpen = "shop-header-module--mobileCategoriesOpen--fxTAJ";